// extracted by mini-css-extract-plugin
export default {"container":"DashCard_container__imEGj"};